module.exports = __webpack_public_path__ + "img/ryjq_role.7892630d.png";